import { useLang } from "@/context/LangContext";

export default function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="lang-toggle"
      className="flex items-center rounded-full border border-border bg-secondary/60 p-0.5 text-xs font-semibold"
    >
      {["en", "es"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className={`px-2.5 py-1 rounded-full transition-colors ${
            lang === l ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
